
<template>
    <div class="content-wrapper">
        <div class="d-flex align-items-center justify-content-between">
            <app-breadcrumb :page-title="$t('purchase_order')"/>
            <button
                v-if="this.$can('create_internal_transfers')"
                type="button"
                class="btn btn-primary btn-with-shadow mb-4"
                @click="openModal()">
                {{ $addLabel('order') }}
            </button>
        </div>

        <div class="card border-0 shadow mb-3">
            <div class="card-body">
                <div class="d-flex">
                    <div>
                        <label class="form-label" for="selectedBarcode">Punched Barcode</label>
                        <input class="form-control" type="text" id="selectedBarcode" v-model="selectedBarcode" @input="onBarcodeInput" autofocus />
                    </div>
                </div>
            </div>
        </div>

        <app-table
            :id="table_id"
            v-if="options.url"
            :options="options"
            @action="triggerActions"
        />

        <app-internal-transfer-create-edit-modal
            v-if="isModalActive"
            v-model="isModalActive"
            :selected-url="selectedUrl"
            @close="isModalActive = false"
        />

        <app-confirmation-modal
            v-if="confirmationModalActive"
            :firstButtonName="$t('yes')"
            modal-class="warning"
            icon="trash-2"
            modal-id="app-confirmation-modal"
            @confirmed="confirmed('internal-transfer-table')"
            @cancelled="cancelled"
        />
    </div>
</template>

<script>

import DatatableHelperMixin from "../../../../common/Mixin/Global/DatatableHelperMixin";
import HelperMixin from "../../../../common/Mixin/Global/HelperMixin";
import {INTERNAL_TRANSFER} from "../../../Config/ApiUrl-CP";
import InternalTransferMixin from "../../Mixins/Stock/InternalTransferMiixn";

export default {
    name: "InternalTransfer",
    mixins: [DatatableHelperMixin, HelperMixin, InternalTransferMixin],
    data() {
        return {
            table_id: 'internal-transfer-table',
            isModalActive: false,
            selectedUrl: '',
            selectedBarcode: "",
            finalBarcode: "",
            debounceTimer: null,
        }
    },
    methods: {
        triggerActions(row, action, active) {
            if (action.title === this.$t('edit')) {
                this.selectedUrl = `${INTERNAL_TRANSFER}/${row.id}`;
                this.isModalActive = true;
            } else if (action.name === 'delete') {
                this.delete_url = INTERNAL_TRANSFER + '/' + row.id;
                this.confirmationModalActive = true;
            } else {
                this.getAction(row, action, active)
            }
        },
        openModal() {
            this.isModalActive = true;
            this.selectedUrl = ''
        },
        onBarcodeInput() {
            clearTimeout(this.debounceTimer);
            this.debounceTimer = setTimeout(() => {
                this.handleBarcodeProcessing();
            }, 500);
        },
        async handleBarcodeProcessing() {
            if (this.selectedBarcode.trim()) {
                this.finalBarcode = this.selectedBarcode;
                this.selectedBarcode = '';
                const response = await this.handleBarcodeChangeStatus(this.finalBarcode);
                this.toastAndReload(response.message, response.tableId);
            }
        },
    }
}
</script>
